var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorXmarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.25c3.305 0 6-2.672 6-6 0-3.305-2.695-6-6-6-3.328 0-6 2.695-6 6 0 3.328 2.672 6 6 6zM4.102 4.352c.21-.211.562-.211.773 0l1.102 1.101 1.101-1.101c.234-.211.586-.211.797 0 .234.234.234.585 0 .796L6.773 6.25l1.102 1.102c.234.234.234.585 0 .796-.21.235-.563.235-.797 0L5.977 7.047 4.875 8.148a.513.513 0 0 1-.773 0c-.235-.21-.235-.562 0-.796L5.203 6.25 4.102 5.148c-.235-.21-.235-.562 0-.796z",
    fill: "#B41400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorXmarkIcon);
export default __webpack_public_path__ + "static/media/error-xmark-icon.8c487979c65cadda2f289928889e75c2.svg";
export { ForwardRef as ReactComponent };